import React from "react";
import { Link } from "react-router-dom";

type TLinkWrapper = {
  children: JSX.Element;
  condition: boolean;
  href: string,
}

const LinkWrapper: React.FC<TLinkWrapper> = ({ condition, children, href }) => {
  return (
    <>
      {condition
        ?
        <Link to={href ? href : '#'}>
          {children}
        </Link>
        :
        <>
          {children}
        </>
      }
    </>
  );
};

export default LinkWrapper;